import React, { useContext } from 'react';
import { getLevelName, getLevelColorForTag } from '@/constants/index';
import { enhancedFormateTimeStamp } from '@/common/utils/index';
import { List, Menu, Dropdown, Typography, Tooltip, Modal } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import ComponentLog from '@/components/component-log';
import MerchantOnlineOperate from '../merchant-online-operate';
import { totalCount } from '@/components/pagination-tips';
import provideActivityLink from '@/components/provide-activity-link';
import goto from '@/common/goto';
import './index.less';
import Copy from '@/components/copy';
import Dongdong from '@/components/dongdong';
// import ActivityFileData from '../activity-fileData';

const { Paragraph } = Typography;

export default function ActivityList({
  data,
  conditions,
  onPagesChange,
  updateConditions,
  history,
  userType,
  hideMore,
}) {
  return (
    <List
      className="new-activity-manage-actlist"
      itemLayout="vertical"
      size="large"
      loading={data.loading}
      dataSource={data.activityPlans}
      pagination={{
        showSizeChanger: false,
        current: conditions.currentPage,
        // 10000 之后后端不支持正常翻页
        total: totalCount(data.totalCount),
        pageSize: conditions.pageSize,
        onChange: onPagesChange,
        hideOnSinglePage: true,
      }}
      renderItem={(item, index) => (
        <List.Item
          className="list-item-wrap"
          key={item.index}
          extra={
            <ListOperateBtn
              history={history}
              updateConditions={updateConditions}
              data={item}
              userType={userType}
              hideMore={hideMore}
            />
          }
        >
          <ListItem item={item} />
        </List.Item>
      )}
    />
  );
}

// List.Item
function ListItem(props) {
  const { item } = props;
  const levelName = getLevelName(item.level, item.otherLevel);
  const isTestAct = item.activityType === 0; // 0:测试活动  1:正式活动

  return (
    <>
      <div className="list-header">
        <span className="list-activity-name">{item.activityName}</span>
        {levelName ? (
          <span
            className="list-tag"
            style={{
              backgroundColor: getLevelColorForTag(item.level),
              color: 'white',
            }}
          >
            {levelName}
          </span>
        ) : null}
        {isTestAct ? <span className="list-tag-actType">测试活动</span> : null}
      </div>
      <div className="new-activity-list-item">
        <div className="max-width_255">
          <div className="margin-bottom_2">
            <Copy text={'活动ID：' + item.planCode + '，' + '主题活动名称：' + item.activityName}>
              活动ID：<span>{item.planCode}</span>
            </Copy>
          </div>
          <div>活动更新时间：{enhancedFormateTimeStamp(item.updateTime, 'YY-MM-DD hh:mm')}</div>
        </div>
        <div className="max-width_255 margin-left_56">
          <div className="margin-bottom_2">
            活动招商截止时间：{enhancedFormateTimeStamp(item.businessEndTime, 'YY-MM-DD hh:mm')}
          </div>
          <div>
            活动创建人：
            <Dongdong name={item.realName} erp={item.createErp} />
          </div>
        </div>
        <div className="margin-left_56 longest-width">
          <div className="margin-bottom_2">
            活动时间：{item.pendingActivityBeginTime || enhancedFormateTimeStamp(item.activityStartTime, 'YY-MM-DD')} 至{' '}
            {item.pendingActivityEndTime || enhancedFormateTimeStamp(item.activityEndTime, 'YY-MM-DD')}
          </div>
          <div className="text-ellipsis">
            <Tooltip placement="top" title={item.organizationName} overlayStyle={{ maxWidth: 350 }}>
              <Paragraph ellipsis>所属部门：{item.organizationName}</Paragraph>
            </Tooltip>
          </div>
        </div>
      </div>
    </>
  );
}

// list中的操作按钮
function ListOperateBtn(props) {
  const { toActivityDetail: linkToActivityDetail, toActivityEdit } = useContext(provideActivityLink.context);
  const { planCode, isMember, activityVersion, activityStatus, btns, ruleVersion } = props.data;

  const isOldMerchantAct = ruleVersion === 0; // 招商规则版本：0：有可见性规则；1：无可见性规则

  function editActivity(planCode) {
    activityVersion === 2 ? goto.merchantActivityEdit(planCode, 1).push() : toActivityEdit(planCode).push();
  }

  function toActivityDetail(planCode) {
    if (activityVersion === 2) {
      // 新版招商活动
      if (activityStatus === 1) {
        // 新版招商活动且已经完成邀请报名
        goto.merchantActivityDetail(planCode).newTab();
      } else {
        // 新版招商活动但是没有完成最后一步邀请报名，点击活动详情后跳转活动修改完成后续的创建
        goto.merchantActivityEdit(planCode).push();
      }
    } else {
      linkToActivityDetail(planCode).newTab();
    }
  }

  const { updateConditions, hideMore } = props;
  const now = Date.now();
  function ToActivityDetail() {
    if (!btns || (btns && btns.detail === 0)) return null;
    return (
      <ComponentLog>
        <a
          clstag="hdgl_1603707393179|2"
          onClick={() => {
            toActivityDetail(planCode);
          }}
          style={{ marginRight: '30px' }}
        >
          进入活动
        </a>
      </ComponentLog>
    );
  }
  function ChangeActivity() {
    if (isOldMerchantAct || !btns || (btns && btns.modify === 0)) return null;
    return (
      <ComponentLog>
        <a clstag="hdgl_1603707393179|3" onClick={() => editActivity(planCode)}>
          修改
        </a>
      </ComponentLog>
    );
  }

  const menu = (
    <Menu>
      {isMember ? (
        <>
          {isOldMerchantAct || (btns && btns.modify === 0) ? null : (
            <Menu.Item key="changeActivity">
              <ChangeActivity />
            </Menu.Item>
          )}
          {btns && btns.online === 0 ? null : (
            <Menu.Item key="merchantOnlineOperate">
              <MerchantOnlineOperate planCode={planCode} online={0} updateConditions={updateConditions} />
            </Menu.Item>
          )}
          {btns && btns.offline === 0 ? null : (
            <Menu.Item key="merchantOnlineOperate">
              <MerchantOnlineOperate planCode={planCode} online={1} updateConditions={updateConditions} />
            </Menu.Item>
          )}
          {/* {btns && btns.fileData === 0 ? null : (
            <Menu.Item key="merchantfileData">
              <ActivityFileData planCode={planCode} updateConditions={updateConditions} />
            </Menu.Item>
          )} */}
        </>
      ) : null}
    </Menu>
  );
  const menuVisible = () => {
    if (!isMember) return true;
    if ((isOldMerchantAct || btns.modify === 0) && btns.online === 0 && btns.offline === 0) return true;
    return false;
  };
  return (
    <div className="list-operate-btn">
      <ToActivityDetail />
      {btns && !hideMore ? (
        <Dropdown overlay={menu} disabled={menuVisible()}>
          <a>
            更多
            <DownOutlined style={{ marginLeft: 6 }} />
          </a>
        </Dropdown>
      ) : null}
    </div>
  );
}
